import moment from 'moment-timezone';

import { alphabet } from '../../reducers/event/compose';
import { getPercentage } from '../../utils/retention';

const timeLabel = {
  DAILY: 'Day',
  WEEKLY: 'Week',
  MONTHLY: 'Month',
};

const complicatedTitle = (i) => {
  const l = alphabet.length;
  return `${alphabet[Math.trunc(i / l)]}.${alphabet[i % l]}`;
};

export const toComplexRetentionChartData = (result, executedQuery, timezone) => {
  const {
    sequence: { type, units },
  } = executedQuery;

  const categories = [...units];

  return Object.entries(structuredClone(result.retentionUnits))
    .filter(([, arr]) => arr.some((item) => item !== 0))
    .flatMap(([date, arr], i, parentArr) => {
      const graphName = moment.tz(Number(date), timezone).format('YYYY-MM-DD');
      const firstEventValue = arr.shift();
      return {
        categories,
        id: parentArr.length > alphabet.length ? complicatedTitle(i) : alphabet[i],
        name: graphName,
        timeUnit: timeLabel[type].toUpperCase(),
        typeGroupBy: 'USERS',
        series: [
          {
            id: 0,
            parentId: parentArr.length > alphabet.length ? complicatedTitle(i) : alphabet[i],
            parentName: graphName,
            data: arr.map((elem, index) => [
              categories[index],
              getPercentage(firstEventValue, elem),
              elem,
              firstEventValue,
            ]),
          },
        ],
      };
    });
};

export const toComplexRetentionByDateChartData = (result, executedQuery) => {
  const {
    sequence: { type, units },
    returnEvent,
  } = executedQuery;

  const categories = [...units];

  return categories.map((value, i, parentArr) => {
    return {
      name: value,
      returnEventName: returnEvent,
      id: parentArr.length > alphabet.length ? complicatedTitle(i) : alphabet[i],
      timeUnit: timeLabel[type].toUpperCase(),
      series: [
        {
          id: 0,
          parentId: parentArr.length > alphabet.length ? complicatedTitle(i) : alphabet[i],
          parentName: value,
          parentReturnEventName: returnEvent,
          data: Object.entries(structuredClone(result.retentionUnits)).map(([date, arr]) => [
            Number(date),
            getPercentage(arr[0], arr[i + 1]),
            arr[i + 1],
            arr[0],
          ]),
        },
      ],
    };
  });
};
